<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">account_balance_wallet</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Gesti&oacute;n de Retiros USDT</h1>
  </div>

  <!-- Mensajes de error y éxito -->
  <div *ngIf="errorMessage" class="error-snackbar mb-4">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <div *ngIf="successMessage" class="success-snackbar mb-4">
    <mat-icon>check_circle</mat-icon>
    <span>{{ successMessage }}</span>
  </div>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de B&uacute;squeda
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Usuario ID</mat-label>
            <input matInput formControlName="userId" placeholder="Ej: 12345" />
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="status">
              <mat-option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
            <mat-icon matPrefix>info</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Inicio</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Fecha Fin</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="Seleccionar fecha">
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="submit" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Buscar
          </button>
          <button type="button" (click)="clearFilters()" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center p-8">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3 text-gray-600">Cargando datos...</span>
  </div>

  <!-- Card Tabla Retiros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="!loading && withdrawals.length > 0">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
          Retiros
        </h2>
        <div class="flex items-center gap-2">
          <span class="text-xs text-gray-600">
            {{ (pagination.page - 1) * pagination.limit + 1 }} -
            {{ Math.min(pagination.page * pagination.limit, pagination.total) }}
            de {{ pagination.total }}
          </span>
          <select [value]="pagination.limit" (change)="onPageSizeChange($event)"
            style="border: 1px solid #d1d5db; border-radius: 6px; padding: 2px 8px; font-size: 0.75rem; background: white; cursor: pointer;">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tabla Desktop: hidden lg:block -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="withdrawals" class="w-full">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let w"><span class="text-xs font-mono">{{ w?.id?.substring(0, 8) || 'N/A' }}...</span></td>
        </ng-container>

        <ng-container matColumnDef="userId">
          <th mat-header-cell *matHeaderCellDef>Usuario</th>
          <td mat-cell *matCellDef="let w">
            <div class="text-xs font-medium">{{ w?.userName || 'N/A' }}</div>
            <div class="text-xs text-gray-400">{{ w?.userEmail || 'Sin email' }}</div>
            <div class="text-xs text-gray-400 font-mono">ID: {{ w?.userId }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="walletAddress">
          <th mat-header-cell *matHeaderCellDef>Wallet</th>
          <td mat-cell *matCellDef="let w">
            <div class="flex items-center gap-1">
              <span class="font-mono text-xs">{{ w?.walletAddress || 'N/A' }}</span>
              <mat-icon *ngIf="w?.walletAddress?.startsWith('***')"
                style="font-size: 14px; width: 14px; height: 14px; color: #ea580c;"
                matTooltip="Wallet enmascarada por seguridad">lock</mat-icon>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="network">
          <th mat-header-cell *matHeaderCellDef>Red</th>
          <td mat-cell *matCellDef="let w"><span class="text-xs">{{ w?.network || 'N/A' }}</span></td>
        </ng-container>

        <ng-container matColumnDef="requestedAmount">
          <th mat-header-cell *matHeaderCellDef>Monto</th>
          <td mat-cell *matCellDef="let w"><span class="text-xs font-bold">{{ formatUSDT(w?.requestedAmount) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="fee">
          <th mat-header-cell *matHeaderCellDef>Fee</th>
          <td mat-cell *matCellDef="let w"><span class="text-xs">{{ formatUSDT(w?.fee) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="netAmount">
          <th mat-header-cell *matHeaderCellDef>Neto</th>
          <td mat-cell *matCellDef="let w"><span class="text-xs font-bold" style="color: #16a34a;">{{ formatUSDT(w?.netAmount) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="approvalType">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let w">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [ngClass]="getApprovalTypeClass(w?.requestedAmount)">
              <mat-icon style="font-size: 12px; width: 12px; height: 12px; vertical-align: middle; margin-right: 2px;">
                {{ getApprovalTypeIcon(w?.requestedAmount) }}
              </mat-icon>
              {{ getApprovalTypeLabel(w?.requestedAmount) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let w">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [ngClass]="getStatusClass(w?.status)">
              {{ getStatusLabel(w?.status) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="requestedAt">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let w"><span class="text-xs text-gray-600">{{ formatDate(w?.requestedAt) }}</span></td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef style="min-width: 160px; text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let w" style="min-width: 160px; text-align: center;">
            <div class="flex flex-wrap items-center justify-center gap-1">
              <button title="Ver detalle" (click)="openDetailModal(w, $event)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #93c5fd; border-radius: 6px; background: #eff6ff; cursor: pointer;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon>
              </button>
              <button *ngIf="w?.status === 'pending'"
                title="Aprueba el retiro (solo lo marca completado, NO lo envía a Binance)" (click)="openConfirmModal(w, $event)"
                style="display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 12px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer; font-size: 12px; font-weight: 600; color: #15803d;"
                onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                <mat-icon style="font-size: 15px; width: 15px; height: 15px; color: #16a34a;">check</mat-icon>
                <span>Aprobar</span>
              </button>
              <button *ngIf="w?.status === 'pending'"
                title="Rechaza el retiro" (click)="openRejectModal(w, $event)"
                style="display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 12px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer; font-size: 12px; font-weight: 600; color: #b91c1c;"
                onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
                <mat-icon style="font-size: 15px; width: 15px; height: 15px; color: #dc2626;">close</mat-icon>
                <span>Rechazar</span>
              </button>
              <button *ngIf="w?.status === 'pending' && pagaBinance(w)"
                title="Envía el retiro USDT a Binance para que se pague" [disabled]="reenviando.has(w.id)" (click)="reenviarABinance(w, $event)"
                style="display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 12px; border: 1px solid #93c5fd; border-radius: 6px; background: #eff6ff; cursor: pointer; font-size: 12px; font-weight: 600; color: #1d4ed8;"
                onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                <mat-icon style="font-size: 15px; width: 15px; height: 15px; color: #2563eb;">send</mat-icon>
                <span>Reenviar a Binance</span>
              </button>
              <!-- Polygon o Solana: Binance no los paga. Se pagan a mano y se cierran con "Aprobar". -->
              <span *ngIf="w?.status === 'pending' && !pagaBinance(w)"
                title="Binance solo paga TRC20: págalo a mano y luego apruébalo"
                style="display: inline-flex; align-items: center; gap: 4px; height: 30px; padding: 0 10px; border: 1px dashed #f59e0b; border-radius: 6px; background: #fffbeb; font-size: 12px; font-weight: 600; color: #b45309;">
                <mat-icon style="font-size: 15px; width: 15px; height: 15px; color: #d97706;">back_hand</mat-icon>
                Pago manual
              </span>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile: lg:hidden -->
    <div class="lg:hidden space-y-3 p-4">
      <div *ngFor="let w of withdrawals; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full shrink-0"
              [ngClass]="getStatusClass(w?.status)">
              {{ getStatusLabel(w?.status) }}
            </span>
            <span class="text-xs font-semibold text-gray-700 truncate">{{ w?.userName || 'N/A' }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-xs font-bold">{{ formatUSDT(w?.requestedAmount) }}</span>
            <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
              expand_more
            </mat-icon>
          </div>
        </div>

        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">ID</span>
              <p class="text-gray-700 font-mono font-medium mt-0.5">{{ w?.id?.substring(0, 12) || 'N/A' }}...</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Red</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ w?.network || 'N/A' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Monto</span>
              <p class="text-gray-700 font-bold mt-0.5">{{ formatUSDT(w?.requestedAmount) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fee</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatUSDT(w?.fee) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Neto</span>
              <p class="font-bold mt-0.5" style="color: #16a34a;">{{ formatUSDT(w?.netAmount) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo</span>
              <p class="font-medium mt-0.5">{{ getApprovalTypeLabel(w?.requestedAmount) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Email</span>
              <p class="text-gray-700 font-medium mt-0.5 truncate">{{ w?.userEmail || 'N/A' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ formatDate(w?.requestedAt) }}</p>
            </div>
            <div class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Wallet</span>
              <p class="text-gray-700 font-mono font-medium mt-0.5 break-all text-xs">{{ w?.walletAddress || 'N/A' }}</p>
            </div>
          </div>
          <div class="flex gap-2 mt-3 pt-3 border-t border-gray-100">
            <button title="Ver detalle" (click)="openDetailModal(w, $event)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #93c5fd; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">visibility</mat-icon>
              Detalle
            </button>
            <button *ngIf="w?.status === 'pending'"
              title="Aprobar" (click)="openConfirmModal(w, $event)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #bbf7d0; border-radius: 8px; background: #f0fdf4; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #16a34a;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #16a34a;">check</mat-icon>
              Aprobar
            </button>
            <button *ngIf="w?.status === 'pending'"
              title="Rechazar" (click)="openRejectModal(w, $event)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">close</mat-icon>
              Rechazar
            </button>
            <button *ngIf="w?.status === 'pending' && pagaBinance(w)"
              title="Reenviar a Binance" [disabled]="reenviando.has(w.id)" (click)="reenviarABinance(w, $event)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #93c5fd; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">send</mat-icon>
              Reenviar a Binance
            </button>
            <span *ngIf="w?.status === 'pending' && !pagaBinance(w)"
              title="Binance solo paga TRC20: págalo a mano y luego apruébalo"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px dashed #f59e0b; border-radius: 8px; background: #fffbeb; font-size: 0.75rem; font-weight: 600; color: #b45309;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #d97706;">back_hand</mat-icon>
              Pago manual
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginaci&oacute;n -->
    <div class="p-4">
      <mat-paginator
        [length]="pagination.total"
        [pageSize]="pagination.limit"
        [pageIndex]="pagination.page - 1"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPaginatorChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>

  <!-- Mensaje cuando no hay datos -->
  <div *ngIf="!loading && withdrawals.length === 0"
    class="bg-white rounded-2xl shadow-md border border-gray-100 text-center py-8">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">inbox</mat-icon>
    <p class="text-lg font-medium text-gray-500 mt-2">No se encontraron retiros</p>
    <p class="text-sm text-gray-400">Intenta ajustar los filtros de b&uacute;squeda</p>
  </div>
</div>

<!-- Modal Aprobar -->
<div *ngIf="showConfirmModal"
  class="fixed inset-0 z-50 flex justify-center items-center"
  style="background: rgba(0,0,0,0.5);"
  (click)="closeConfirmModal()">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 overflow-hidden" (click)="$event.stopPropagation()">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">check_circle</mat-icon>
        Confirmar Aprobaci&oacute;n de Retiro
      </h2>
    </div>
    <div class="p-5">
      <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-md flex items-start gap-2">
        <mat-icon class="text-red-600 text-sm">error</mat-icon>
        <span class="text-red-700 text-sm">{{ errorMessage }}</span>
      </div>

      <div class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md flex items-start gap-2">
        <mat-icon class="text-blue-600 text-sm">info</mat-icon>
        <div class="text-blue-700 text-sm">
          <p class="font-semibold">&iquest;Est&aacute; seguro que desea aprobar este retiro?</p>
          <p *ngIf="pagaBinance(selectedWithdrawal)" class="text-xs mt-1">Aprobar solo cambia el estado del retiro a completado: no se env&iacute;a nada a Binance. Para enviarlo usa &laquo;Reenviar a Binance&raquo;.</p>
          <p *ngIf="!pagaBinance(selectedWithdrawal)" class="text-xs mt-1">Este retiro es por la red {{ selectedWithdrawal?.network }} y Binance no lo paga. Apru&eacute;balo cuando ya lo hayas pagado a mano: aprobar solo lo marca completado y registra el d&eacute;bito.</p>
        </div>
      </div>

      <!-- TxId del pago (opcional): queda en el retiro y en el correo al cliente. -->
      <div class="mb-4">
        <label for="txIdPago" class="block text-xs font-semibold text-gray-700 mb-1">TxId del pago (opcional)</label>
        <input id="txIdPago" type="text" [(ngModel)]="txIdPago" autocomplete="off"
          placeholder="Hash de la transacci&oacute;n, si lo tienes"
          class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm font-mono focus:outline-none focus:ring-2 focus:ring-green-500">
      </div>

      <div *ngIf="selectedWithdrawal" class="bg-gray-50 p-4 rounded-md border border-gray-200">
        <h4 class="text-sm font-semibold text-gray-700 mb-3">Detalles del Retiro:</h4>
        <div class="text-sm space-y-2">
          <div class="p-3 rounded-md border"
            [ngClass]="requiresManualApproval(selectedWithdrawal.requestedAmount) ? 'bg-orange-50 border-orange-200' : 'bg-blue-50 border-blue-200'">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <mat-icon class="text-sm"
                  [ngClass]="requiresManualApproval(selectedWithdrawal.requestedAmount) ? 'text-orange-600' : 'text-blue-600'">
                  {{ getApprovalTypeIcon(selectedWithdrawal.requestedAmount) }}
                </mat-icon>
                <span class="font-semibold"
                  [ngClass]="requiresManualApproval(selectedWithdrawal.requestedAmount) ? 'text-orange-700' : 'text-blue-700'">
                  Tipo: {{ getApprovalTypeLabel(selectedWithdrawal.requestedAmount) }}
                </span>
              </div>
              <span class="px-2 py-1 rounded-full text-xs font-semibold"
                [ngClass]="getApprovalTypeClass(selectedWithdrawal.requestedAmount)">
                {{ requiresManualApproval(selectedWithdrawal.requestedAmount) ? '≥ $5,000' : '< $5,000' }}
              </span>
            </div>
            <p class="text-xs mt-2 ml-6"
              [ngClass]="requiresManualApproval(selectedWithdrawal.requestedAmount) ? 'text-orange-600' : 'text-blue-600'">
              {{ requiresManualApproval(selectedWithdrawal.requestedAmount)
                 ? 'Este retiro requiere aprobación manual debido al monto solicitado.'
                 : 'Este retiro se procesará automáticamente una vez aprobado.' }}
            </p>
          </div>

          <div class="bg-white p-3 rounded-md border border-blue-100">
            <div class="flex items-center gap-2 mb-2">
              <mat-icon class="text-blue-600 text-sm">person</mat-icon>
              <span class="font-semibold text-gray-700">Informaci&oacute;n del Usuario</span>
            </div>
            <div class="ml-6 space-y-1">
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Nombre:</span>
                <span class="font-medium text-xs">{{ selectedWithdrawal.userName || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Email:</span>
                <span class="font-medium text-xs break-all">{{ selectedWithdrawal.userEmail || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">ID:</span>
                <span class="font-mono text-xs text-gray-500">{{ selectedWithdrawal.userId }}</span>
              </div>
            </div>
          </div>

          <div class="flex justify-between pt-2">
            <span class="text-gray-600">Monto Solicitado:</span>
            <span class="font-bold">{{ formatUSDT(selectedWithdrawal.requestedAmount) }} USDT</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">Monto Neto:</span>
            <span class="font-bold" style="color: #16a34a;">{{ formatUSDT(selectedWithdrawal.netAmount) }} USDT</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">Red:</span>
            <span class="font-medium">{{ selectedWithdrawal.network }}</span>
          </div>
          <div class="border-t pt-2 mt-2">
            <span class="text-gray-600 text-xs">Wallet:</span>
            <p class="break-all font-mono text-xs mt-1">{{ selectedWithdrawal.walletAddress }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="px-5 pb-5 flex flex-col sm:flex-row justify-center gap-3">
      <button type="button" (click)="confirmWithdrawal()" [disabled]="loading"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        [style.opacity]="loading ? '0.5' : '1'"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon *ngIf="!loading" style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
        <mat-spinner diameter="16" *ngIf="loading"></mat-spinner>
        {{ loading ? 'Procesando...' : 'Aprobar Retiro' }}
      </button>
      <button type="button" (click)="closeConfirmModal()" [disabled]="loading"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
        Cancelar
      </button>
    </div>
  </div>
</div>

<!-- Modal Rechazar -->
<div *ngIf="showRejectModal"
  class="fixed inset-0 z-50 flex justify-center items-center"
  style="background: rgba(0,0,0,0.5);"
  (click)="closeRejectModal()">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 overflow-hidden" (click)="$event.stopPropagation()">
    <div style="background: linear-gradient(135deg, #fef2f2, #fee2e2); padding: 16px 24px; border-bottom: 2px solid #fecaca;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #991b1b; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #dc2626;">cancel</mat-icon>
        Confirmar Rechazo de Retiro
      </h2>
    </div>
    <div class="p-5">
      <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-md flex items-start gap-2">
        <mat-icon class="text-red-600 text-sm">error</mat-icon>
        <span class="text-red-700 text-sm">{{ errorMessage }}</span>
      </div>

      <div class="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-md flex items-start gap-2">
        <mat-icon class="text-orange-600 text-sm">warning</mat-icon>
        <div class="text-orange-700 text-sm">
          <p class="font-semibold">&iquest;Est&aacute; seguro que desea rechazar este retiro?</p>
          <p class="text-xs mt-1">El saldo bloqueado ser&aacute; liberado y retornado al usuario.</p>
        </div>
      </div>

      <div *ngIf="selectedWithdrawal" class="bg-gray-50 p-4 rounded-md border border-gray-200 mb-4">
        <h4 class="text-sm font-semibold text-gray-700 mb-3">Detalles del Retiro:</h4>
        <div class="text-sm space-y-2">
          <div class="bg-white p-3 rounded-md border border-orange-100">
            <div class="flex items-center gap-2 mb-2">
              <mat-icon class="text-orange-600 text-sm">person</mat-icon>
              <span class="font-semibold text-gray-700">Informaci&oacute;n del Usuario</span>
            </div>
            <div class="ml-6 space-y-1">
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Nombre:</span>
                <span class="font-medium text-xs">{{ selectedWithdrawal.userName || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Email:</span>
                <span class="font-medium text-xs break-all">{{ selectedWithdrawal.userEmail || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">ID:</span>
                <span class="font-mono text-xs text-gray-500">{{ selectedWithdrawal.userId }}</span>
              </div>
            </div>
          </div>
          <div class="flex justify-between pt-2">
            <span class="text-gray-600">Monto Neto:</span>
            <span class="font-bold text-gray-900">{{ formatUSDT(selectedWithdrawal.netAmount) }} USDT</span>
          </div>
          <div class="flex justify-between">
            <span class="text-gray-600">Red:</span>
            <span class="font-medium">{{ selectedWithdrawal.network }}</span>
          </div>
        </div>
      </div>

      <form [formGroup]="rejectForm">
        <div class="mb-4">
          <label for="reason" class="block text-sm font-medium text-gray-700 mb-2">
            Motivo del Rechazo <span class="text-gray-400 text-xs">(opcional)</span>
          </label>
          <textarea id="reason" formControlName="reason" rows="3"
            placeholder="Ej: Wallet address inv&aacute;lida, fondos insuficientes, etc."
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"></textarea>
        </div>
      </form>
    </div>
    <div class="px-5 pb-5 flex flex-col sm:flex-row justify-center gap-3">
      <button type="button" (click)="rejectWithdrawal()" [disabled]="loading"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        [style.opacity]="loading ? '0.5' : '1'"
        onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
        <mat-icon *ngIf="!loading" style="font-size: 18px; width: 18px; height: 18px; color: white;">close</mat-icon>
        <mat-spinner diameter="16" *ngIf="loading"></mat-spinner>
        {{ loading ? 'Procesando...' : 'Rechazar Retiro' }}
      </button>
      <button type="button" (click)="closeRejectModal()" [disabled]="loading"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
        Cancelar
      </button>
    </div>
  </div>
</div>

<!-- Modal Detalle -->
<div *ngIf="showDetailModal && selectedWithdrawal"
  class="fixed inset-0 z-50 flex justify-center items-center"
  style="background: rgba(0,0,0,0.5);"
  (click)="closeDetailModal()">
  <div class="bg-white rounded-2xl shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <div class="flex justify-between items-center">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">receipt_long</mat-icon>
          Detalle del Retiro
        </h2>
        <button type="button" (click)="closeDetailModal()"
          style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: none; border-radius: 6px; background: transparent; cursor: pointer;"
          onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='transparent'">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">close</mat-icon>
        </button>
      </div>
    </div>
    <div class="p-5">
      <div class="space-y-4">
        <!-- General Info -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">ID</label>
            <p class="text-gray-900 font-mono text-xs mt-0.5">{{ selectedWithdrawal.id }}</p>
          </div>
          <div>
            <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Estado</label>
            <p class="mt-0.5">
              <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
                [ngClass]="getStatusClass(selectedWithdrawal.status)">
                {{ getStatusLabel(selectedWithdrawal.status) }}
              </span>
            </p>
          </div>
        </div>

        <!-- User Info -->
        <div class="border-t pt-4">
          <h4 class="text-sm font-bold text-gray-800 mb-3">Informaci&oacute;n del Usuario</h4>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">User ID</label>
              <p class="text-gray-900 text-sm mt-0.5">{{ selectedWithdrawal.userId }}</p>
            </div>
            <div>
              <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Nombre</label>
              <p class="text-gray-900 text-sm mt-0.5">{{ selectedWithdrawal.userName || 'N/A' }}</p>
            </div>
            <div class="col-span-1 sm:col-span-2">
              <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Email</label>
              <p class="text-gray-900 text-sm mt-0.5">{{ selectedWithdrawal.userEmail || 'N/A' }}</p>
            </div>
          </div>
        </div>

        <!-- Transaction Info -->
        <div class="border-t pt-4">
          <h4 class="text-sm font-bold text-gray-800 mb-3">Informaci&oacute;n de la Transacci&oacute;n</h4>
          <div class="space-y-3">
            <div class="p-3 rounded-md border"
              [ngClass]="requiresManualApproval(selectedWithdrawal.requestedAmount) ? 'bg-orange-50 border-orange-200' : 'bg-blue-50 border-blue-200'">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <mat-icon class="text-base"
                    [ngClass]="requiresManualApproval(selectedWithdrawal.requestedAmount) ? 'text-orange-600' : 'text-blue-600'">
                    {{ getApprovalTypeIcon(selectedWithdrawal.requestedAmount) }}
                  </mat-icon>
                  <span class="font-semibold text-sm"
                    [ngClass]="requiresManualApproval(selectedWithdrawal.requestedAmount) ? 'text-orange-700' : 'text-blue-700'">
                    Tipo: {{ getApprovalTypeLabel(selectedWithdrawal.requestedAmount) }}
                  </span>
                </div>
                <span class="px-2 py-1 rounded-full text-xs font-semibold"
                  [ngClass]="getApprovalTypeClass(selectedWithdrawal.requestedAmount)">
                  {{ requiresManualApproval(selectedWithdrawal.requestedAmount) ? '≥ $5,000' : '< $5,000' }}
                </span>
              </div>
            </div>

            <div>
              <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Wallet Address</label>
              <p class="text-gray-900 break-all font-mono text-xs mt-0.5">{{ selectedWithdrawal.walletAddress }}</p>
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-3 gap-3">
              <div>
                <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Moneda</label>
                <p class="text-gray-900 text-sm mt-0.5">{{ selectedWithdrawal.coin }}</p>
              </div>
              <div>
                <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Red</label>
                <p class="text-gray-900 text-sm mt-0.5">{{ selectedWithdrawal.network }}</p>
              </div>
            </div>
            <div class="grid grid-cols-3 gap-3">
              <div>
                <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Monto Solicitado</label>
                <p class="text-lg font-semibold text-gray-900 mt-0.5">{{ formatUSDT(selectedWithdrawal.requestedAmount) }}</p>
              </div>
              <div>
                <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Fee</label>
                <p class="text-lg font-semibold text-gray-900 mt-0.5">{{ formatUSDT(selectedWithdrawal.fee) }}</p>
              </div>
              <div>
                <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Monto Neto</label>
                <p class="text-lg font-semibold mt-0.5" style="color: #16a34a;">{{ formatUSDT(selectedWithdrawal.netAmount) }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Binance Info -->
        <div *ngIf="selectedWithdrawal.binanceTxId" class="border-t pt-4">
          <h4 class="text-sm font-bold text-gray-800 mb-3">Informaci&oacute;n de Binance</h4>
          <div>
            <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Transaction ID</label>
            <p class="text-gray-900 break-all font-mono text-xs mt-0.5">{{ selectedWithdrawal.binanceTxId }}</p>
          </div>
        </div>

        <!-- Rejection Info -->
        <div *ngIf="selectedWithdrawal.rejectionReason" class="border-t pt-4">
          <h4 *ngIf="selectedWithdrawal.status === 'rejected'" class="text-sm font-bold text-gray-800 mb-3">Informaci&oacute;n de Rechazo</h4>
          <h4 *ngIf="selectedWithdrawal.status !== 'rejected'" class="text-sm font-bold text-gray-800 mb-3">&Uacute;ltimo intento fallido en Binance</h4>
          <div>
            <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Motivo</label>
            <p class="text-gray-900 text-sm mt-0.5">{{ selectedWithdrawal.rejectionReason }}</p>
          </div>
        </div>

        <!-- Reenvíos a Binance (registro administrativo) -->
        <div *ngIf="selectedWithdrawal.reenvios?.length" class="border-t pt-4">
          <h4 class="text-sm font-bold text-gray-800 mb-3">Reenv&iacute;os a Binance</h4>
          <div *ngFor="let r of selectedWithdrawal.reenvios" class="mb-2">
            <p class="text-gray-900 text-sm">{{ r.createdAt | date: 'dd/MM/yyyy HH:mm' }} &middot; {{ r.operatorEmail || r.operatorId }}</p>
            <p *ngIf="r.previousReason" class="text-gray-500 text-xs">Intento anterior: {{ r.previousReason }}</p>
          </div>
        </div>

        <!-- Dates -->
        <div class="border-t pt-4">
          <h4 class="text-sm font-bold text-gray-800 mb-3">Fechas</h4>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Solicitado</label>
              <p class="text-gray-900 text-sm mt-0.5">{{ formatDate(selectedWithdrawal.requestedAt) }}</p>
            </div>
            <div *ngIf="selectedWithdrawal.completedAt">
              <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Completado</label>
              <p class="text-gray-900 text-sm mt-0.5">{{ formatDate(selectedWithdrawal.completedAt) }}</p>
            </div>
          </div>
        </div>

        <!-- Operators Info -->
        <div *ngIf="selectedWithdrawal.confirmedBy || selectedWithdrawal.rejectedBy" class="border-t pt-4">
          <h4 class="text-sm font-bold text-gray-800 mb-3">Operadores</h4>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div *ngIf="selectedWithdrawal.confirmedBy">
              <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Confirmado por</label>
              <p class="text-gray-900 text-sm mt-0.5">{{ selectedWithdrawal.confirmedBy }}</p>
            </div>
            <div *ngIf="selectedWithdrawal.rejectedBy">
              <label class="text-xs font-semibold text-gray-400 uppercase" style="font-size: 0.65rem;">Rechazado por</label>
              <p class="text-gray-900 text-sm mt-0.5">{{ selectedWithdrawal.rejectedBy }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="px-5 pb-5 flex justify-center">
      <button type="button" (click)="closeDetailModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
        Cerrar
      </button>
    </div>
  </div>
</div>
